import { render, staticRenderFns } from "./BlockArea.vue?vue&type=template&id=f3c9f170&scoped=true"
import script from "./BlockArea.vue?vue&type=script&lang=js"
export * from "./BlockArea.vue?vue&type=script&lang=js"
import style0 from "./BlockArea.vue?vue&type=style&index=0&id=f3c9f170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c9f170",
  null
  
)

export default component.exports